import * as React from 'react';

/**
 * Utilitário para evitar conflitos de scroll em componentes flutuantes (SelectContent, PopoverContent, etc).
 * Impede que o scroll do mouse ou touch "vaze" para o body ou modais inferiores.
 */
export const stopScrollPropagation = (e: React.WheelEvent | React.TouchEvent) => {
  e.stopPropagation();
};

/**
 * Hook para gerenciar o scroll do body quando um componente (como um Drawer customizado) está aberto.
 * Nota: Radix Dialog já faz isso automaticamente, mas útil para componentes customizados ou comportamentos extras.
 */
export const useLockBodyScroll = (isLocked: boolean) => {
  React.useEffect(() => {
    if (isLocked) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [isLocked]);
};
